import { NetWealthCardComponent } from '@1bill-app/components/net-wealth-card/net-wealth-card.component';
import { FirstTimeUserAnimationPopoverComponent } from '@1bill-app/components/popover/first-time-user-animation-popover/first-time-user-animation-popover.component';
import { PopoverSimpleComponent } from '@1bill-app/components/popover/popover-simple/popover-simple.component';
import { PopoverUpdateBalanceComponent } from '@1bill-app/components/popover/popover-update-balance/popover-update-balance.component';
import {
  EXPLANATION_NOTES_SIMPLE,
  ONEBILL_APP_ID,
  ROUTE_BILL_DETAILS,
  ROUTE_EMAIL_SCANNER_JOBS,
  ROUTE_HOMEPAGE,
  ROUTE_UPLOAD_YOUR_BILL,
  ROUTE_OFFERS,
  ROUTE_BILLS_PAGE,
  ROUTE_POINTS_INFO,
  ROUTE_CONNECT_EMAIL,
  MOBILE_VIEW_THRESHOLD_PX,
  SALARY_INTERVAL_OPTIONS,
  ROUTE_EMAIL_SCANNER,
} from '@1bill-app/constants';
import { BillQuery } from '@1bill-app/services/bill/bill.query';
import { BillCategoryKey, BillRating } from '@1bill-app/services/bill/types';
import { CategoryService } from '@1bill-app/services/category/category.service';
import { HomeStore } from '@1bill-app/services/home/home.store';
import { NotificationService } from '@1bill-app/services/notification/notification.service';
import { OfferQuery } from '@1bill-app/services/offer/offer.query';
import { Offer } from '@1bill-app/services/offer/offer.type';
import { OfferService } from '@1bill-app/services/offer/offer.service';
import { RewardQuery } from '@1bill-app/services/reward/reward.query';
import { RewardService } from '@1bill-app/services/reward/reward.service';
import { RewardState } from '@1bill-app/services/reward/reward.type';
import { SettingsQuery } from '@1bill-app/services/settings/settings.query';
import { SettingsService } from '@1bill-app/services/settings/settings.service';
import { AccountPreference } from '@1bill-app/services/settings/settings.store';
import { StatusQuery } from '@1bill-app/services/status/status.query';
import { StatusService } from '@1bill-app/services/status/status.service';
import { JobState } from '@1bill-app/services/status/types';
import { UserService } from '@1bill-app/services/user/user.service';
import { UserQuery } from '@1bill-app/services/user/user.query';
import { UserAccountTerminationStatus } from '@1bill-app/services/user/user.types';
import { YodleeQuery } from '@1bill-app/services/yodlee/yodlee.query';
import { YodleeService } from '@1bill-app/services/yodlee/yodlee.service';
import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Market } from '@ionic-native/market/ngx';
import {
  AlertButton,
  AlertController,
  IonContent,
  LoadingController,
  NavController,
  Platform,
  PopoverController,
  ToastController,
} from '@ionic/angular';
import _ from 'lodash';
import { NGXLogger } from 'ngx-logger';
import { combineLatest, Observable, forkJoin } from 'rxjs';
import {
  debounceTime,
  tap,
  map,
  startWith,
  switchMap,
  mergeMap,
  filter,
  take,
} from 'rxjs/operators';
import { DASHBOARD_PREFERENCES } from 'src/app/data/dashboard-preference.data';
import { SubSink } from 'subsink';
import { BillService } from './../../services/bill/bill.service';
import { HomeQuery } from './../../services/home/home.query';
import { HomeService } from './../../services/home/home.service';
import { AuthQuery } from '@1bill-app/services/auth/state/auth.query';
import { YodleeAccount, YodleeWealthInfoGroup } from '@1bill-app/services/yodlee/yodlee.types';
import { AddSalaryModalComponent } from '@1bill-app/components/add-salary-modal/add-salary-modal.component';
import { BillsSalaryChartComponent } from '@1bill-app/components/bills-salary-chart/bills-salary-chart.component';
import { WealthChartComponent } from '@1bill-app/components/wealth-chart/wealth-chart.component';
import dayjs from 'dayjs';
import { _orderBy } from '@1bill-app/helpers/lodash.helper';
import { AddBillPopoverComponent } from '@1bill-app/components/popover/add-bill-popover/add-bill-popover.component';
import { groupBy } from 'lodash';
import { SwitchAndSaveConsentComponent } from '@1bill-app/components/popover/switch-and-save-consent/switch-and-save-consent.component';
import { OnebillEvent } from '@1bill-app/services/home/home.type';
import { SwitchProcessCallbackResponse } from '@1bill-app/services/api/api.service';

// declare let AndroidNotch: any;

/**
 * Page for home page contents in tabs.
 */
@Component({
  selector: 'app-tab-home',
  templateUrl: './tab-home.page.html',
  styleUrls: ['./tab-home.page.scss'],
})
export class TabHomePage implements OnInit, OnDestroy {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChild('netWealthCard') netWealthCard: NetWealthCardComponent;
  @ViewChild('billsSalaryChart') billsSalaryChart: BillsSalaryChartComponent;
  @ViewChild('wealthChart') wealthChart: WealthChartComponent;

  // Element formerly used to scroll to content. As this element was discarded with the new design,
  //   attempting to scroll to it just scrolls back to the top of the page.
  // @ViewChild('upcomingBillsElement', { static: false }) upcomingBillsElement: ElementRef;
  /**
   * New element used to scroll to content as it contains the dummy jobs now.
   */
  @ViewChild('billBlockListWrapper') billBlockListWrapper: ElementRef;

  constructor(
    private logger: NGXLogger,
    private homeService: HomeService,
    public homeQuery: HomeQuery,
    public homeStore: HomeStore,
    public billQuery: BillQuery,
    public billService: BillService,
    public statusQuery: StatusQuery,
    public statusService: StatusService,
    public rewardQuery: RewardQuery,
    public rewardService: RewardService,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private _settings: SettingsService,
    private settingsQuery: SettingsQuery,
    private _zone: NgZone,
    private toastController: ToastController,
    private alertController: AlertController,
    private router: Router,
    private categorySvc: CategoryService,
    private platform: Platform,
    private yodleeService: YodleeService,
    private yodleeQuery: YodleeQuery,
    private popoverController: PopoverController,
    private notificationService: NotificationService,
    private userQuery: UserQuery,
    private userService: UserService,
    private market: Market,
    private loadingController: LoadingController,
    private offerQuery: OfferQuery,
    private offerService: OfferService,
    private authQuery: AuthQuery,
  ) {
    this.route.queryParams.forEach((param) => {
      const { refetch, job } = param;
      if (refetch) {
        // this.showScrollToCreditScoreChip = true;
        this.navCtrl.navigateRoot([ROUTE_HOMEPAGE]);
        setTimeout(() => {
          this.scrollToTop();
        }, 500);
      }

      if (job) {
        this.jobsLoading = true;
        this.statusQuery.isCurrentJobOnProgress$.subscribe(
          ({ jobOnprogress, jobsLoaded }) => {
            if (jobsLoaded) this.jobsLoading = false;
            if (jobOnprogress && !this.isPullToRefresh) this.scrollToJobs();
          },
          (err) => {
            this.jobsLoading = false;
          },
        );
        this.router.navigate(['.'], { relativeTo: this.route });
      }
    });
    this.authQuery.isLoggedIn$.subscribe((isLoggedIn) => {
      this.isLoggedIn = isLoggedIn;
      this.dashboardView = 'bill-management';
    });

    if (this.userHasFullAccess) {
      this.route.queryParams.subscribe(async (p) => {
        this.logger.log('received params:', p);
  
        this.billService.updateSwitch(p as SwitchProcessCallbackResponse);
      });

      this.yodleeQuery.accountListUpdated$
        .pipe(filter((updated) => !!updated))
        .subscribe((type: string) => {
          setTimeout(() => {
            // getWealthInformation: update the accounts information (liability and assets total amounts)
            // getDashboardWealthData: get information for the wealth chart to update
            // getAccounts: get information about the total number of accounts
            forkJoin([
              this.yodleeService.getWealthInformation(),
              this.yodleeService.getDashboardWealthData(),
              this.yodleeService.getAccounts(),
            ]).subscribe((a) => {
              this.refreshWealthChart();
            });
          }, 1000);
        });
    }
  }

  subs = new SubSink();
  JobState = JobState;
  isLoggedIn = false;
  // duplicatedArray: Array<string>;
  // observer
  // private pcObserver: MutationObserver;
  public error$ = this.isError();

  public isBillProgressInView$ = this.homeQuery.isBillProgressInView$;
  public events$ = this.homeQuery.events$.pipe(
    map((events) => {
      // Filter out all switch_promo events if the user does not have FULL access.
      events = this.userQuery.userHasFullAccess
        ? events
        : events.filter((event) => event.eventType !== 'switch_promo');
      return events;
    }),
  );
  public profile$ = this.homeQuery.select('profile');
  public switchData$ = this.homeQuery.select('switchData');
  public homeLoaded$ = this.homeQuery.select('loaded').pipe(startWith(false));
  public profileRewards$ = this.rewardQuery.profileReward$;

  /**
   * Recalls timeout in case `getBill` is never called on new accounts.
   * If `getBill` is called, even if there is no data, it fixes some issues
   * that would occur if it was never called.
   */
  private checkBillTimeout: NodeJS.Timeout;
  private refetchSettingsInterval: NodeJS.Timeout;
  private checkRegistrationCompleteInterval: NodeJS.Timeout;

  public billLoaded$ = this.billQuery.select('loaded').pipe(startWith(false));
  public billsThisMonth$ = this.billQuery.billsThisMonth$.pipe(
    map((bills) =>
      bills.sort((bill1, bill2) => (dayjs(bill1.dueDate).isBefore(bill2.dueDate) ? -1 : 1)),
    ),
  );

  public savingsBills$ = this.billQuery.savingsBills$.pipe(
    map((savingsBills) => {
      //group bills by category and address
      //Remove duplicates if bill is of same category and address
      const groupedBills = groupBy(savingsBills, (bill) => {
        return `${bill.categoryKey} ${bill.fullAddress}`;
      });

      let billOffer = [];
      //loop to only show the latest based on groupBy
      for (const key in groupedBills) {
        const value = groupedBills[key];
        billOffer.push(value[0]);
      }

      // Only bills that have less than excellent should be shown as the point
      // is to show bills where users could save by switching.
      return (
        billOffer
          .filter((bill) => bill.rating < BillRating.Perfect)
          //display the latest bill
          .sort((bill1, bill2) => bill1.savingPerYear - bill2.savingPerYear)
      );
    }),
  );

  public predictionsThisMonth$ = this.billQuery.predictions$.pipe(
    map((predictions) => {
      return predictions.filter((prediction) => {
        const currentDate = dayjs();
        const predictedDueDate = dayjs(prediction.predictedDueDate);
        return predictedDueDate.diff(currentDate, 'days') <= 30;
        // Below return statement is for bills within current month, not within 30 days
        // return currentDate.month() === predictedDueDate.month() && currentDate.year() === predictedDueDate.year();
      });
    }),
    //Sort by nearest due date first
    map((predictions) => {
      return _orderBy(
        predictions,
        [(prediction) => (prediction.predictedDueDate ? prediction.predictedDueDate : '')],
        ['asc'],
      );
    }),
  );
  public recentlyUploadedBills$ = this.billQuery.recentlyUploadedBills$;
  public overdueBills$ = this.billQuery.overdueBills$;

  public isJobOnProgress$ = this.statusQuery.isJobOnProgress$;
  public isPollingComplete$ = this.statusQuery.isPollingComplete$;

  public homeDataEvent$ = this.homeService.homeDataEvent$;

  public homePaymentCard$ = this.settingsQuery.homePaymentCard$;
  public firstName$ = this.settingsQuery.select('firstName');

  public rewardState$ = this.rewardQuery.select((state) => state);
  public connectedEmail$ = this.rewardQuery.connectedEmail$;

  public userSalary$ = this.userQuery.userSalary$;
  public loginCount$ = this.userQuery.loginCount$;

  public isPullToRefresh: boolean;
  public billsLoading: boolean;
  public routeHomePage = ROUTE_HOMEPAGE;
  public showBillProgressChip: boolean;

  public terminationData: UserAccountTerminationStatus;
  hideAccountTerminationComponent = true;

  totalBillSaving: number;
  loadingTotalBillSaving = true;

  SALARY_INTERVAL_OPTIONS = SALARY_INTERVAL_OPTIONS;

  public creditCheckScore$ = this.homeQuery.creditCheckScore$.pipe(
    map((result) => {
      this.logger.log('this.homeQuery.creditCheckScore$', result);
      return result?.score;
    }),
  );
  public creditCheckScoreDate$ = this.homeQuery.creditCheckScore$.pipe(
    map((result) => {
      // this.logger.log('this.homeQuery.creditCheckScore$', result);
      return result?.scoreDate;
    }),
  );

  public yodleeAccounts$ = this.yodleeQuery.accounts$;
  public yodleeAccountSummaries$ = this.yodleeQuery.summaries$;
  public accountWealthInfoGroups$ = this.yodleeQuery.wealthCategories$;
  public netWealthChartData$ = this.yodleeQuery.netWealthChartData$;
  public categorySummaries$ = this.yodleeQuery.categorySummaries$;

  assetWealthInfo: YodleeWealthInfoGroup[];
  liabilityWealthInfo: YodleeWealthInfoGroup[];

  /**
   * Gets offers that the user can redeem, in descending order of points amount.
   * This will be displayed in the 'Rewards for you' list.
   */
  public tailoredOffers$ = this.offerQuery.tailoredOffers$;

  loadingTailoredRewards = true;
  tailoredRewards: Offer[] = [];

  /**
   * Set by subscribeFetchAllData() completion result after `billPayments` in `BillStore` is set.
   * If set `false` by default, the placeholder of the bills chart will be displayed before the app
   * can accurately determine whether or not the user has any bills.
   */
  userHasAnyBills = true;

  allAccounts: YodleeAccount[];
  assetAccounts: YodleeAccount[];
  liabilityAccounts: YodleeAccount[];

  billsChartLoaded = false;
  billsSalaryChartLoaded = false;

  public allAccounts$: Observable<YodleeAccount[]> = this.route.queryParams.pipe(
    mergeMap(() =>
      this.yodleeQuery.accounts$.pipe(
        map((accounts) => {
          this.allAccounts = accounts;
          return accounts;
        }),
      ),
    ),
  );

  public assetAccounts$: Observable<YodleeAccount[]> = this.route.queryParams.pipe(
    mergeMap(() =>
      this.yodleeQuery.accounts$.pipe(
        map((accounts) => {
          this.assetAccounts = accounts?.filter((account) => account.wealthType === 'asset');

          return accounts?.filter((account) => account.wealthType === 'asset');
        }),
      ),
    ),
  );

  public liabilityAccounts$: Observable<YodleeAccount[]> = this.route.queryParams.pipe(
    mergeMap(() =>
      this.yodleeQuery.accounts$.pipe(
        map((accounts) => {
          this.liabilityAccounts = accounts?.filter(
            (account) => account.wealthType === 'liability',
          );

          return accounts?.filter((account) => account.wealthType === 'liability');
        }),
      ),
    ),
  );

  trackByFn(account: YodleeAccount) {
    return account?.id;
  }

  trackByFnGroup(group: YodleeWealthInfoGroup) {
    return group.type;
  }

  // public showScrollToCreditScoreChip = false;
  get isDesktopView() {
    return this.platform.width() >= MOBILE_VIEW_THRESHOLD_PX;
  }

  get userCanUploadBills() {
    return this.userQuery.userCanAddBills;
  }

  get userHasFullAccess() {
    return this.userQuery.userHasFullAccess;
  }

  public jobsLoading = false;
  public jobsOnProgress$ = this.statusQuery.jobsOnProgress$;
  public totalJobCount$ = this.statusQuery.totalJobCount$;
  public showBalance$ = this.homeQuery.showBalance$;
  public dashboardPreferences: AccountPreference[];
  public dashboardPreferences$ = this.homeQuery.preferences$;
  public nativePlatform: 'ios' | 'android' = this.platform.is('ios') ? 'ios' : 'android';
  public nativeMarket = this.nativePlatform == 'ios' ? 'App Store' : 'Play Store';
  public dashboardView: 'bill-management' | 'wealth-summary' = 'bill-management';
  emailScannedBillsToVerify$ = this.billQuery.emailScannedBillsToVerify$;
  routeEmailScannerJobs = ROUTE_EMAIL_SCANNER_JOBS;
  homeLoading$ = this.homeQuery.select('loaded').pipe(
    startWith(false),
    switchMap((homeLoaded) => {
      return this.billQuery.select('loaded').pipe(
        startWith(false),
        map((billLoaded) => !billLoaded || !homeLoaded),
      );
    }),
  );

  readonly ROUTE_OFFERS = ROUTE_OFFERS;
  readonly ROUTE_BILLS_PAGE = ROUTE_BILLS_PAGE;
  readonly ROUTE_HOMEPAGE = ROUTE_HOMEPAGE;
  readonly ROUTE_POINTS_INFO = ROUTE_POINTS_INFO;

  async presentUpdateBalance(event) {
    const popover = await this.popoverController.create({
      component: PopoverUpdateBalanceComponent,
    });
    return await popover.present();
  }

  handleLinkBankAccount() {
    this.homeService.presentLinkBankAccountModal().then((modal) => {
      modal
        ?.onWillDismiss()
        .then((modal: { data: 'backButton' | 'gotoManual' | 'onClose'; role: any }) => {
          if (modal.data === 'onClose') {
            this.yodleeQuery.accountListUpdated$.next('bankAccount');
          }
        });
    });
  }

  trackByOrder(dashPref: AccountPreference) {
    return dashPref?.order;
  }

  handleConnectEmail() {
    this.router.navigateByUrl(ROUTE_EMAIL_SCANNER);
  }

  handleAddBill() {
    this.homeService.addBillEvent();
  }

  dashboardViewChange() {
    if (this.dashboardView === 'wealth-summary') {
      this.refreshWealthChart(100);
    }
  }

  trackBy1bEvents(index: number, event: OnebillEvent) {
    return `${event.key}:${event.header}`;
  }

  refreshWealthChart(timeout = 1000) {
    setTimeout(() => {
      this.wealthChart?.refreshChart();
    }, timeout);
  }

  getInitData() {
    this.subs.sink = this.isPollingComplete$.subscribe((completed) => {
      if (completed) {
        this.logger.debug('isPollingComplete', completed);
        this.triggerJobCompleteAction();
        this.statusService.updateUI({ isPollingComplete: null });
      }
    });
    this.subs.sink = this.isJobOnProgress$.subscribe((processing) => {
      if (processing) {
        this.logger.debug('isJobOnProgress', processing);
        this.homeService.setBillProgressInView(false);
      }
    });
    this.subs.sink = this.homeService.homeDataEvent$
      .pipe(debounceTime(500))
      .subscribe((trigger) => {
        if (trigger) {
          this._zone.run(() => {
            this.logger.debug('TabHomePage::homeDataEvent$', trigger);
            this.subscribeFetchAllData(trigger?.forceRefresh);
          });
        }
      });
    this.subs.sink = this.homeService.scrollToTop$.subscribe(({ trigger }) => {
      if (trigger) {
        this.scrollToTop();
      }
    });
    this.subs.sink = this.error$.subscribe((res) => {
      if (res) {
        this.jobsLoading = false;
        this.errorAlert();
      }
    });
    this.subscribeFetchAllData();
    if (this.isLoggedIn) {
      // These functions should only run on non-dummy page
      // Removed. Some data doesn't load here on sign-out and sign-in
    }
  }

  async ngOnInit() {
    this.rewardService.getRewards().subscribe();

    // Detecting notch on Android devices - most likely not needed as it
    // appears that the viewport of the 1Bill app already avoids the notched
    // areas.
    // if (typeof AndroidNotch?.hasCutout === 'function') {
    //   AndroidNotch.hasCutout((success) => {
    //     console.log('AndroidNotch hasCutout:', success);
    //   }, (error) => {
    //     console.warn('hasCutout error:', error);
    //   });
      
    //   AndroidNotch.getInsetTop((px) => {
    //     console.log('getInsetTop px:', px);
    //   }, (error) => {
    //     console.warn('getInsetTop error:', error);
    //   });
  
    //   AndroidNotch.getInsetRight((px) => {
    //     console.log('getInsetRight px:', px);
    //   }, (error) => {
    //     console.warn('getInsetRight error:', error);
    //   });
  
    //   AndroidNotch.getInsetBottom((px) => {
    //     console.log('getInsetBottom px:', px);
    //   }, (error) => {
    //     console.warn('getInsetBottom error:', error);
    //   });
  
    //   AndroidNotch.getInsetLeft((px) => {
    //     console.log('getInsetLeft px:', px);
    //   }, (error) => {
    //     console.warn('getInsetLeft error:', error);
    //   });
    // }
    
    // Yodlee APIs to only be called if user has full access.
    if (this.userHasFullAccess) {
      this.subs.sink = this.yodleeService.getAccounts().subscribe();
      this.subs.sink = this.yodleeService
        .getWealthInformation()
        .subscribe((wealthInfoGroups) => {
          this.assetWealthInfo = wealthInfoGroups.asset;
          this.liabilityWealthInfo = wealthInfoGroups.liability;
          this.logger.log('Wealth Info Groups:', wealthInfoGroups);
        });
    }

    this.subs.sink = this.userService.accountTerminationStatusChange.subscribe(() => {
      this.userService
        .getAccountTerminationStatusFromDatabase()
        .subscribe((newTerminationData) => {
          // Continue showing the account termination component (for its confirmation message) if the API result updates and
          // confirms that the user has not requested another account termination
          this.hideAccountTerminationComponent =
            newTerminationData?.terminationPending === 1
              ? false
              : this.hideAccountTerminationComponent;
          this.terminationData = newTerminationData;
        });
    });
    const completed = this.isLoggedIn
      ? await this.userService.getUserRegistrationComplete()
      : false;
    if (completed || !this.isLoggedIn) {
      this.getInitData();
    } else if (this.isLoggedIn) {
      // User registration complete flag not yet set to 1
      this.loadingController
        .create({
          mode: 'ios',
          message: 'Please wait a few moments while your account is set up...',
        })
        .then((loader) => {
          // Initial call failed; show loader until successful
          loader.present();
          loader.onWillDismiss().finally(() => {
            this.getInitData();
          });

          // setTimeout() so that the 2nd getUserRegistrationComplete call does not happen immediately.
          const RETRY_LIMIT = 5;
          let retries = 1;
          setTimeout(() => {
            // Check if getUserRegistrationComplete is available every 2000ms
            this.checkRegistrationCompleteInterval = setInterval(async () => {
              const registrationStatus = await this.userService.getUserRegistrationComplete();
              if (registrationStatus) {
                clearInterval(this.checkRegistrationCompleteInterval);
                loader.dismiss();
              }
              if (retries > RETRY_LIMIT) {
                loader.dismiss();
                clearInterval(this.checkRegistrationCompleteInterval);
                this.alertController
                  .create({
                    header: 'An error occurred',
                    subHeader: 'Failed to load data',
                    message:
                      'Sorry, your account failed to load. Please try again later, or refresh the page. If neither work, get into contact with us.',
                    buttons: ['OK'],
                  })
                  .then((alert) => {
                    alert.present();
                  });
              }
              retries++;
            }, 2000);
          }, 2000);
        });
    }
    // this.subs.sink = this.billService.fetchBill().subscribe(); // required ???
    this.billQuery.totalBillSaving$.subscribe((res) => {
      this.totalBillSaving = res;
      // Sometimes the subscription completes very quickly with undefined values before being able to fetch the data
      this.loadingTotalBillSaving = res === undefined || res === null;
      if (this.loadingTotalBillSaving) {
        this.checkBillTimeout = setTimeout(() => {
          this.billService.getBill(true).subscribe();
        }, 5000);
      } else {
        clearTimeout(this.checkBillTimeout);
      }
    });

    this.loginCount$.pipe(take(1)).subscribe((loginCount) => {
      if (typeof loginCount !== 'number') {
        // triggerUserLogin() is only called when the user signs in.
        // On page refresh it isn't called, so the user login count must be obtained
        // with a separate call.
        this.userService.getUserLoginCount().subscribe();
      }
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (this.userHasFullAccess) {
          this.subs.sink = this.yodleeService.getAccounts().subscribe();
          this.subscribeFetchAllData(true);
          this.wealthChart?.refreshChart();
        }
      });
  }

  checkAllRewardsCompleted(rewardState: RewardState) {
    const rewards = rewardState?.rewards?.filter(
      (reward) => rewardState?.pcaCodes?.indexOf(reward?.actionCode) >= 0,
    );
    return rewards?.every((x) => x?.completed === 1) ?? false;
  }

  onBillsChartLoad(loaded: boolean) {
    this.billsChartLoaded = loaded;
    this.userHasAnyBills = !!this.billQuery.getValue().billPayments?.length;
  }

  onBillsSalaryChartLoad(loaded: boolean) {
    this.billsSalaryChartLoaded = loaded;
  }

  ionViewDidEnter() {
    this.handleAddBillRedirect();
    if (this.isLoggedIn) {
      this.subs.sink = this.homeService
        .getAllData()
        .subscribe(({ home, accountTerminationStatus }) => {
          this.terminationData = accountTerminationStatus;
          // Determine whether the account termination component should be shown or not depending on the first result of API
          this.hideAccountTerminationComponent =
            accountTerminationStatus.terminationPending !== 1;

          const prefs = home?.preferences;
          if (prefs?.length > 0) this.dashboardPreferences = prefs;
          else this.dashboardPreferences = DASHBOARD_PREFERENCES;
          // this.logger.debug('Dashboard preferences: ', this.dashboardPreferences);
        });
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    // Clear all intervals
    clearInterval(this.refetchSettingsInterval);
    clearInterval(this.checkRegistrationCompleteInterval);
  }

  ConvertToInt(val) {
    return parseInt(val);
  }

  toggleShowBalance() {
    this.homeStore.update((state) => ({
      ...state,
      showBalance: !state.showBalance,
    }));
  }

  triggerJobCompleteAction() {
    this.logger.log('TabHomePage::triggerJobCompleteAction() => call', {
      billPayments: this.billQuery.getValue()?.billPayments,
      progress: this.statusQuery.isJobOnProgress,
    });
    this.subscribeFetchAllData(true);
    if (
      this.billQuery.getValue()?.billPayments?.length > 0 &&
      !this.statusQuery.isJobOnProgress
    ) {
      const job = this.statusQuery.latestJob;
      this.logger.debug('job state', job);
      switch (job.state) {
        case JobState.SUCCESS:
          this.logger.debug(
            'TabHomePage::triggerJobCompleteAction() success => scrollIntoView',
          );
          this.addBill(job?.bpId);
          this.subs.sink = this.yodleeService.getTransactions().subscribe();
          this.presentSuccessfulBill(job?.bpId);
          if (this.userHasFullAccess) {
            this.subs.sink = this.yodleeService.getTransactions().subscribe();
          }
          break;
        case JobState.DUPLICATE:
          this.presentDuplicateBill(job?.bpId);
          break;
        case JobState.FAILED:
          this.presentUploadFailed();
          break;
        case JobState.INVALID:
          this.presentInvalidBill();
          break;
        default:
          break;
      }
    }
  }

  /**
   * Show this only when there was an issue with the bill and it was later corrected manually.
   */
  async presentSuccessfulBill(billPaymentId: number) {
    const alert = await this.alertController.create({
      mode: 'ios',
      cssClass: 'bill-alert alert-icon',
      message:
        '<img style="margin-top: 2rem;" src="assets/icon/alert/success.svg" alt="warning-icon" /><h2 class="alert-title">Upload process complete</h2><p class="alert-text">We managed to process all the information in your bill.</p>',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'See bill',
          cssClass: 'bill-alert alert-icon see-bill-btn',
          handler: () => {
            this.router.navigate([ROUTE_BILL_DETAILS], {
              queryParams: { _source: ROUTE_HOMEPAGE, billPaymentId: billPaymentId },
            });
          },
        },
      ],
    });

    await alert.present();
  }

  async presentDuplicateBill(billPaymentId: number) {
    const billIds = this.billQuery.getValue().billPayments.map((bill) => bill.billPaymentId);
    const userHasDuplicate = billIds.includes(billPaymentId);
    const alert = await this.alertController.create({
      mode: 'ios',
      cssClass: 'bill-alert alert-icon',
      message:
        '<img src="assets/icon/alert/warning.svg" alt="Warning" /><h2 class="alert-title">Duplicate bill</h2><p class="alert-text">The bill you have just uploaded is already in our system.</p>',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: userHasDuplicate ? 'See bill' : 'Okay',
          handler: () => {
            if (userHasDuplicate) {
              this.router.navigate([ROUTE_BILL_DETAILS], {
                queryParams: { _source: ROUTE_HOMEPAGE, billPaymentId: billPaymentId },
              });
            }
          },
        },
      ],
    });

    await alert.present();
  }

  async errorAlert() {
    const alert = await this.alertController.create({
      mode: 'ios',
      cssClass: 'bill-alert alert-icon',
      message:
        '<img src="assets/icon/alert/warning.svg" alt="Warning" /><h2 class="alert-title">Oops!</h2><p class="alert-text">Something went wrong! Please try again later.</p>',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Got it',
          handler: () => { },
        },
      ],
    });

    await alert.present();
  }

  async openAppInMarket() {
    const marketAppId =
      this.nativePlatform === 'ios' ? ONEBILL_APP_ID.ios : ONEBILL_APP_ID.android;
    await this.market.open(marketAppId);
  }

  async presentInvalidBill() {
    const alert = await this.alertController.create({
      mode: 'ios',
      cssClass: 'bill-alert alert-icon',
      message:
        '<img src="assets/icon/alert/warning.svg" alt="warning-icon" /><h2 class="alert-title">Invalid bill</h2><p class="alert-text">We could not identify the bill type uploaded. Please upload a valid bill.</p>',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Add bill',
          handler: () => {
            this.navCtrl.navigateForward([ROUTE_UPLOAD_YOUR_BILL, 'pdf']);
          },
        },
      ],
    });

    await alert.present();
  }

  async presentUploadFailed() {
    const alert = await this.alertController.create({
      mode: 'ios',
      cssClass: 'bill-alert alert-icon',
      message:
        '<ion-icon class="hourglass-warning-icon" name="hourglass-outline" alt="warning-icon"></ion-icon><h2 class="alert-title">Bill details need to be verified.</h2><p class="alert-text">Some of the details on your bill need to be verified. An operator is checking this, and the updated/confirmed details should be available shortly.</p>',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Okay',
          cssClass: 'none',
        },
      ],
    });

    await alert.present();
  }

  /* 
  "This bill has already been uploaded. The duplicate bill will be removed." 
  "This <bill type> bill has already been uploaded. The duplicate bill will be removed." */
  async presentAlreadyUploadedToast(billPaymentId) {
    if (!billPaymentId) {
      this.logger.debug('Duplicate Job billPaymentId absent!!!');
      return;
    }
    const toast = await this.toastController.create({
      message: 'This bill has already been uploaded.',
      // duration: 2000,
      color: 'warning',
      buttons: [
        {
          side: 'end',
          text: 'Go to bill',
          handler: () => {
            this.logger.debug('Favorite clicked');
            this.navCtrl.navigateForward([ROUTE_BILL_DETAILS, billPaymentId]);
          },
        },
        {
          side: 'start',
          // text: 'Cancel',
          icon: 'close-outline',
          role: 'cancel',
          handler: () => {
            this.logger.debug('Cancel clicked');
          },
        },
      ],
    });
    await toast.present();
  }

  async presentToast(success: boolean, message: string) {
    const toast = await this.toastController.create({
      message,
      // duration: 2000,
      buttons: [
        {
          side: 'end',
          // text: 'Cancel',
          icon: 'close-outline',
          role: 'cancel',
          handler: () => {
            this.logger.debug('Cancel clicked');
          },
        },
      ],

      color: success ? 'success' : 'danger',
    });
    await toast.present();
  }

  subscribeFetchAllData(forceRefresh = false) {
    if (this.isLoggedIn) {
      this.homeService
        .fetchAllData(forceRefresh)
        .pipe(
          tap(({ home }) => {
            const prefs = home.data?.preferences;
            if (prefs?.length > 0) {
              this.dashboardPreferences = prefs;
            } else {
              this.dashboardPreferences = DASHBOARD_PREFERENCES;
            }
            this.checkJobStatus();
          }),
          switchMap(() => this.rewardService.getRewards(true)),
        )
        .subscribe(() => {
          // Getting offers must happen after the fetchAllData, because it relies on the
          // userPoints value to determine which offers to show to the customer. User
          // points are fetched from `this.rewardService.getRewards(true)`.
          this.offerService.getOffers().subscribe();
        });

      this.tailoredOffers$.subscribe((offers) => {
        if (Array.isArray(offers)) {
          this.tailoredRewards = offers;
          this.loadingTailoredRewards = false;
        }
      });

      // This data must be refreshed each time user logs in as the wealth chart would otherwise
      // be blank when the user signs out and signs back in due to the YodleeStore being flushed.
      if (this.userHasFullAccess) {
        this.subs.sink = this.yodleeService.getDashboardWealthData().subscribe();
        this.subs.sink = this.yodleeService.getAccounts().subscribe();
        this.subs.sink = this.yodleeService.getWealthInformation().subscribe();
      }
      this.subs.sink = this.notificationService.getNotifications().subscribe();
      this.subs.sink = this._settings.fetch().subscribe({
        error: (e) => {
          let refetchCount = 0;
          clearInterval(this.refetchSettingsInterval);
          this.refetchSettingsInterval = setInterval(() => {
            this._settings
              .fetch()
              .toPromise()
              .then(async (settingsResult) => {
                if (settingsResult) {
                  this.logger.log(
                    `Refetched settings after ${refetchCount} tries:`,
                    settingsResult,
                  );
                  clearInterval(this.refetchSettingsInterval);
                } else {
                  if (++refetchCount > 1) {
                    clearInterval(this.refetchSettingsInterval);
                    const toastWarning = await this.toastController.create({
                      message: 'Sorry, an error occurred while fetching settings.',
                      duration: 3000,
                      color: 'danger',
                    });
                    await toastWarning.present();
                    throw Error(`Could not resolve settings after ${refetchCount} retries.`);
                  }
                }
              })
              .catch(async (err) => {
                if (++refetchCount > 2) {
                  clearInterval(this.refetchSettingsInterval);
                  const toastWarning = await this.toastController.create({
                    message:
                      'Sorry, an error occurred while fetching settings: ' + err.message,
                    duration: 3000,
                    color: 'danger',
                  });
                  await toastWarning.present();
                  throw Error(`Could not resolve settings after ${refetchCount} retries.`);
                }
              });
          }, 5000);
        },
      });
    } else {
      this.offerService.getDummyOffers().toPromise().then((offers) => {
        this.tailoredRewards = offers as any;
      }).finally(() => {
        this.loadingTailoredRewards = false;
      });
    }
  }

  scrollToTop() {
    this.logger.debug('TabHomePage::scrollToTop() => call');
    if (this.content) {
      this.logger.debug('TabHomePage::scrollToTop() => scroll content');
      if (this.content.scrollToTop(1500)) {
        this.logger.debug('home scroll true');
      } else {
        this.logger.debug('home scroll false');
      }
    }
    // this.showScrollToCreditScoreChip = false;
  }

  scrollToJobs() {
    this.dashboardView = 'bill-management';
    this.logger.debug('TabHomePage::billBlockListWrapper:', this.billBlockListWrapper);
    setTimeout(() => {
      this.logger.debug('TabHomePage::scrollToJobs() => call');
      if (this.content && !this.isPullToRefresh) {
        const offsetTop = this.billBlockListWrapper.nativeElement.offsetTop;
        this.logger.debug(`TabHomePage::scrollToJobs() => scroll content "${offsetTop}"`);
        this.content.scrollToPoint(0, offsetTop - 20, 1500).then(() => {
          this.logger.debug('home scroll complete');
        });
      }
    }, 50);
  }

  doRefresh(event) {
    this.isPullToRefresh = true;
    this.homeService.fetchAllData(true).subscribe({
      next: () => {
        this.isPullToRefresh = false;
        event.target.complete();
        this.checkJobStatus();
      },
      error: (err) => {
        this.isPullToRefresh = false;
        event.target.complete();
        this.logger.error('home pull to refresh fetch data error', err);
      },
    });
  }

  checkJobStatus(hasInitialDelay = true) {
    if (this.statusQuery.isJobOnProgress) {
      this.subs.sink = this.statusService.pollFetch(hasInitialDelay).subscribe();
    }
  }

  handleAddBillRedirect() {
    this.route.queryParamMap.subscribe((q) => {
      if (q.get('job')) {
        // this.checkJobStatus(false);
        this.homeService.fetchAllData().subscribe(({ }) => {
          this.checkJobStatus(false);
        });
      }
    });
  }

  isError() {
    return combineLatest([this.billQuery.selectError(), this.homeQuery.selectError()]).pipe(
      map((list) => list.some((v) => !!v)),
    );
  }

  isLoading() {
    return combineLatest([
      this.billQuery.selectLoading(),
      this.homeQuery.selectLoading(),
    ]).pipe(map((list) => list.some((v) => !!v)));
  }

  getDetails(categoryKey: BillCategoryKey) {
    return this.categorySvc.getCategoryDetails(categoryKey);
  }

  async presentInfoPopoverBankAc() {
    const popover = await this.popoverController.create({
      component: PopoverSimpleComponent,
      cssClass: 'onebill-bottom-popover',
      // translucent: true,
      mode: 'ios',
      componentProps: {
        popoverTitle: EXPLANATION_NOTES_SIMPLE.YD_BANK_AC_TITLE,
        descriptionArray: EXPLANATION_NOTES_SIMPLE.YD_BANK_AC_DESC,
      },
    });
    return await popover.present();
  }

  async presentFirstTimeAnimation() {
    const popover = await this.popoverController.create({
      component: FirstTimeUserAnimationPopoverComponent,
      mode: 'ios',
      cssClass: 'first-time-modal',
    });
    await popover.present();
    popover.onDidDismiss().then((updated) => {
      if (updated) {
      }
    });
  }



  async addSalary() {
    const salaryQueryValue = this.userQuery.getValue().salaryPerInterval;
    this.popoverController
      .create({
        component: AddSalaryModalComponent,
        componentProps: {
          salary: salaryQueryValue,
          interval: this.userQuery.getValue().salaryInterval,
        },
        cssClass: 'add-salary-modal',
      })
      .then((popover) => {
        popover.present();
        popover.onWillDismiss().then(async ({ data }) => {
          if (typeof data?.salary === 'number' && !isNaN(data?.salary)) {
            const loader = await this.loadingController.create({
              message: salaryQueryValue ? 'Updating salary...' : 'Adding salary...',
            });
            loader.present();
            this.userService
              .updateSalary(data.salary, data.interval)
              .toPromise()
              .then(() => {
                this.toastController
                  .create({
                    color: 'success',
                    duration: 3000,
                    message: `Added salary of $${data.salary}`,
                  })
                  .then((toast) => {
                    toast.present();
                  });

                this.billsSalaryChart?.reloadChart(data.salary);
              })
              .catch((error) => {
                this.logger.error('Error updating salary:', error);
                this.toastController
                  .create({
                    color: 'danger',
                    duration: 3000,
                    message: `Sorry, something went wrong!`,
                  })
                  .then((errorToast) => {
                    errorToast.present();
                  });
              })
              .finally(() => {
                loader.dismiss();
              });
          } else if (data?.deleteSalary === true) {
            const loader = await this.loadingController.create({
              message: 'Removing salary...',
            });
            loader.present();
            this.userService
              .deleteSalary()
              .toPromise()
              .then(() => {
                this.toastController
                  .create({
                    color: 'success',
                    duration: 3000,
                    message: `Your salary is no longer saved to your account.`,
                  })
                  .then((toast) => {
                    toast.present();
                  });
              })
              .catch((error) => {
                this.logger.error('Error removing salary:', error);
                this.toastController
                  .create({
                    color: 'danger',
                    duration: 3000,
                    message: 'Sorry, something went wrong!',
                  })
                  .then((errorToast) => {
                    errorToast.present();
                  });
              })
              .finally(() => {
                loader.dismiss();
              });
          }
        });
      });
  }


  async switchConsent() {
    const popover = await this.popoverController.create({
      component: SwitchAndSaveConsentComponent,
      cssClass: 'switch-and-save-consent-popover',
    });
    return await popover.present();
  }


  async addBill(latestbillId: number) {
    const popover = await this.popoverController.create({
      component: AddBillPopoverComponent,
      componentProps:
        { billPaymentId: latestbillId },
      cssClass: 'add-bill-popover',
    });
    this.popoverController.dismiss();
    return await popover.present();
  }
}



